import moment from 'moment';
import octes from '../../images/octes';
import logoXOM from '../../images/logos/logo_XOM.png';
import logoSMC from '../../images/logos/logo_smc_compacte.png';

const prefixOctes = 'octes8h_';
const heightIconesEstatCel = 18;
const widthIconesEstatCel = 18;

//Configuració general i comuna de la gràfica Highchart
export const configuracioGenericaGrafica = {
    chart: {
        type: 'line',
        alignTicks: false,
    },
    exporting: {
        enabled: true,
        sourceWidth: 950,
        scale: 1,
        chartOptions: {
            chart: {
                events: {
                    load: function () {
                        //Possar els logos només al exportar
                        this.renderer.image(logoSMC, 6, 5, 64, 20).add();
                        this.renderer.image(logoXOM, 80, 5, 58, 20).add();
                    }
                }
            }
        },
        csv: {
            dateFormat: '%d-%m-%Y',
            decimalPoint: '.',
            itemDelimiter: ';',
            columnHeaderFormatter: function (series) {
                const seriesReconegudes = ['Temperatura sec', 'Temperatura humit', 'Humitat', 'Precipitació 24h', 'Temperatura màx.', 'Temperatura mín.'];
                const serieAEliminar = 'Series 4';

                const obtenirNomColumnesEspecials = (nomSerie) => {
                    return nomSerie === serieAEliminar ? '' : 'Data';
                };

                return seriesReconegudes.includes(series.name) ? series.name : obtenirNomColumnesEspecials(series.name);
            }
        },
        buttons: {
            contextButton: {
                menuItems: ['printChart', 'separator', 'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG', 'separator', 'downloadCSV']
            }
        }
    },
    useMultiLevelHeaders: false,
    credits: {
        enabled: true,
        text: 'Servei Meteorològic de Catalunya',
        href: 'http://www.meteo.cat',
    },
    xAxis: {
        type: 'datetime'
    },
    tooltip: {
        crosshairs: true,
        shared: true,
        useHTML: true,
        borderColor: function () {
            return '#000000';
        },
        formatter: tooltipFormater
    },
    legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
    },
    plotOptions: {
        spline: {
            lineWidth: 2,          //ancho de las lineas
            states: {
                hover: {
                    lineWidth: 5   //ancho de la linea al pasar el raton por encima
                }
            },
            marker: {
                enabled: true     //mustra o no un marcador encima de la linea
            }
        }
    }
};

export const configuracioGraficaPerPeriode = () => ({
    '24h': {    //es el valor que tenim a la propietat periodeSelecionat.
        yAxis: [
            {
                gridLineWidth: 0,
                title: {
                    text: 'Temperatura (°C)'
                },
                softMin: 0,
                allowDecimals: false
            },
            {
                title: {
                    text: 'Precipitació total 24h (mm)'
                },
                opposite: true,
                softMin: 0,
                allowDecimals: false
            }
        ],
        series: [
            {
                id: 34,
                name: 'Precipitació 24h',
                yAxis: 1,
                tooltip: {
                    valueSuffix: 'mm'
                },
                type: 'column',
                color: 'rgba(154, 236, 219, 0.6)'
            },
            {
                id: 4,
                name: 'Temperatura màx.',
                tooltip: {
                    valueSuffix: 'ºC'
                },
                color: '#e74c3c'
            },
            {
                id: 6,
                name: 'Temperatura mín.',
                tooltip: {
                    valueSuffix: 'ºC'
                },
                color: '#3498db'
            }
        ]
    },
    '8h': {    //es un dels dos valors que pot tenir la propietat periodeSelecionat
        chart: {
            events: {
                render: onRender
            }
        },
        legend: {
            margin: 80
        },
        yAxis: [
            {
                title: {
                    text: 'Temperatura (°C)'
                },
                gridLineWidth: 0,
                softMin: 0,
                allowDecimals: false
            },
            {
                title: {
                    text: 'Humitat (%)'
                },
                opposite: true,
                min: 0,
                max: 100,
                allowDecimals: false
            }
        ],
        series: [
            {
                id: 1,
                name: 'Temperatura sec',
                yAxis: 0,
                color: '#e74c3c',
                tooltip: {
                    valueSuffix: 'ºC'
                }
            },
            {
                id: 2,
                name: 'Temperatura humit',
                color: '#3498db',
                tooltip: {
                    valueSuffix: 'ºC'
                },
                yAxis: 0
            },
            {
                id: 3,
                name: 'Humitat',
                color: '#38ada9',
                yAxis: 1,
                tooltip: {
                    valueSuffix: '%'
                }
            }
        ]
    }
});

function crearElementVariableCel(milliseconds, observacionsCel, etiqueta) {
    const puntCobertaTotal = observacionsCel.find((element) => {
        return element[0] === milliseconds;
    });

    if (puntCobertaTotal) {
        const valorCoberturaTotal = puntCobertaTotal[1];

        if (valorCoberturaTotal !== null) {
            return '<tr><td>' + etiqueta + ': ' + valorCoberturaTotal + '</td></tr>';
        }
    }

    return '';
}

/**
 * Funció que retonar en format HTML el contingut del tooltip de la gràfica.
 * @param {Object} tooltip
 */
function tooltipFormater(tooltip) {
    var htmlText = '<p class="observacio-exportacio-grafica-tooltip-data">' + moment(this.x).format('DD-MM-YYYY') + '</p>';

    htmlText += '<table>';
    this.points.forEach((point) => {
        htmlText += `<tr><td><span style="color: ${point.series.color} ">\u25CF</span> ${point.series.name} :
            </td><td style="white-space:nowrap"> ${point.y} ${point.series.options.tooltip.valueSuffix} </td></tr>`;
    });

    //Recuperar el valor corresponent a les variables de nuvolss
    const variablesCel = tooltip.chart.options.observacionsVariableCel;
    const milliseconds = this.x;

    if (variablesCel) {
        if (variablesCel.coberturaTotal) {
            htmlText += crearElementVariableCel(milliseconds, variablesCel.coberturaTotal, 'Coberta total');
        }

        if (variablesCel.nuvolsBaixos) {
            htmlText += crearElementVariableCel(milliseconds, variablesCel.nuvolsBaixos, 'Núvols baixos');
        }
    }

    htmlText += '</table>';

    return htmlText;
}

/**
 * Funció que pinta els icones del estat del cel. S'utilitza com funció al executar el event render.
 */
function onRender() {
    //NOTA. l'he possat al render perque es pogui imprimir

    //Se eleiminan los elementos SVG creados porque sino se acumularian
    if (this.svgElements) {
        this.svgElements.forEach((svgElement) => {
            svgElement.destroy();
        });
    }

    if (this.options && !this.options.observacionsVariableCel) return;

    this.svgElements = [];
    //coordenada que indica el inicio de la gràfica
    const y = this.plotTop + this.plotHeight + 35;

    const groupTextTitol = this.renderer.g().add();

    //Buscar la serie amb els valors buits. id = 0
    const serieAmbValorsBuits = this.series.find((serie) => {
        return serie.options.id === 0;
    });

    const dibuixaSimbolsPerVariablesCel = (point, index) => {

        const offset = 10;  //desplazamiento hacia la izquierda respecto al tick
        const x = point.plotX + this.plotLeft - offset;

        const group = this.renderer.g().add();
        this.svgElements.push(group);

        const crearElementSVGPerNuvols = (renderer, group, x, y, punt) => {
            const puntCobertaTotal = punt;
            const valor = puntCobertaTotal[1];  //la posicion 0 seria la fecha en milisegundos

            const valorAsStringCobertaTotal = prefixOctes.concat(valor);

            renderer.image(
                octes[valorAsStringCobertaTotal],
                x,
                y,
                heightIconesEstatCel,
                widthIconesEstatCel
            ).add(group);
        };

        if (this.options.observacionsVariableCel.coberturaTotal) {
            crearElementSVGPerNuvols(this.renderer, group, x, y, this.options.observacionsVariableCel.coberturaTotal[index]);
        }

        if (this.options.observacionsVariableCel.nuvolsBaixos) {
            crearElementSVGPerNuvols(this.renderer, group, x, y + 30, this.options.observacionsVariableCel.nuvolsBaixos[index]);
        }
    };

    serieAmbValorsBuits.data.forEach(dibuixaSimbolsPerVariablesCel, this);

    const htmlElementCoberturaTotal = '<text class="observacio-exportacio-grafica-nom-serie">COBNUV</text>';
    this.renderer.text(htmlElementCoberturaTotal, 2, y + 12).add(groupTextTitol, true);

    const htmlElementNuvolsBaixos = '<text class="observacio-exportacio-grafica-nom-serie">COBNUVB</text>';
    this.renderer.text(htmlElementNuvolsBaixos, 2, y + 42).add(groupTextTitol);

    this.svgElements.push(groupTextTitol);
}



// WEBPACK FOOTER //
// ./src/components/observacio/configuracioExportacio.js